import { buildQuoteCarouselMessage, sendQuoteCarousel, type QuoteCarouselCartItem } from './quoteCarousel';
import { buildQuoteTextMessage, sendQuoteText, type QuoteSendFormat } from './quoteText';
import { formatNameBR } from './personName';

export interface QuoteDeliveryInput {
  supplierId: string;
  phone: string;
  clientName: string | null;
  proposalUrl: string;
  items: QuoteCarouselCartItem[];
  format: QuoteSendFormat;
}

/** Direct delivery only: never open WhatsApp or silently switch formats on failure. */
export async function sendQuoteDirect(input: QuoteDeliveryInput): Promise<boolean> {
  if (!input.supplierId || !input.phone) return false;
  if (input.format === 'text') {
    return sendQuoteText(input.supplierId, input.phone, buildQuoteTextMessage(input.clientName, input.proposalUrl));
  }
  const result = await sendQuoteCarousel({
    supplierId: input.supplierId,
    phone: input.phone,
    message: buildQuoteCarouselMessage(formatNameBR(input.clientName)),
    proposalUrl: input.proposalUrl,
    items: input.items,
  });
  return result.success;
}